"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationPackage',
  data: function data() {
    return {
      loading: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: ''
      },
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  created: function created() {
    this.loadCurrent();
  },
  methods: {
    actionText: function actionText(value) {
      return {
        add_item: '加明细',
        submit: '提交补充',
        fill: '完成补充',
        price: '优价上架',
        cancel: '取消'
      }[value] || value;
    },
    loadCurrent: function loadCurrent() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationPackageListApi)(this.searchForm).then(function (data) {
        _this.tableData.data = data.list || [];
        _this.tableData.total = data.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.loadCurrent();
    },
    openCreate: function openCreate() {
      var _this2 = this;
      this.$prompt('套餐名称', '新套餐').then(function (_ref) {
        var value = _ref.value;
        (0, _decoration.decorationPackageSaveApi)({
          name: value || '整装施工套餐',
          packageType: 'construction',
          basePrice: 19999,
          itemName: '基础施工',
          itemType: 'craft'
        }).then(function () {
          _this2.$message.success('套餐已创建');
          _this2.loadCurrent();
        });
      }).catch(function () {});
    },
    runAction: function runAction(row, action) {
      var _this3 = this;
      var payload = {
        action: action
      };
      if (action === 'add_item') {
        payload.itemName = '主材包';
        payload.itemType = 'material';
        payload.unitPrice = 8000;
      }
      this.$confirm("\u786E\u8BA4".concat(this.actionText(action), "\uFF1F")).then(function () {
        (0, _decoration.decorationPackageActionApi)(row.pkg.id, payload).then(function () {
          _this3.$message.success('套餐已更新');
          _this3.loadCurrent();
        });
      }).catch(function () {});
    }
  }
};